import React from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import { isNull } from '../../../utils/chart';

import scss from './MessagesList.module.scss';

function TotalScores({ total, totalR1, totalR2 }) {
  const { t } = useTranslation('resonance');

  const totalScoresData = [
    {
      label: t('total'),
      value: isNull(total) ? '-/-' : total + '%',
    },
    {
      label: t('totalType', { type: 'R1' }),
      value: isNull(totalR1) ? '-/-' : totalR1 + '%',
      color: scss.blue,
    },
    {
      label: t('totalType', { type: 'R2' }),
      value: isNull(totalR2) ? '-/-' : totalR2 + '%',
      color: scss.green,
    },
  ];

  return (
    <div className={scss.totalScoresWrapper}>
      {totalScoresData.map(({ label, value, color }) => (
        <div key={label}>
          <span>{label}:</span>
          <span className={clsx(color)}>{value}</span>
        </div>
      ))}
    </div>
  );
}

export default TotalScores;
